import { useState } from 'react'
import styles from './styles.module.css'
import {
  CloundArrowUp,
  Cross,
  Interrogation,
  Trash,
} from '../../assets/svgs/icons'
import { motion } from 'framer-motion'

export const ModalGallery = ({ onClose, onSave }) => {
  const [filesSelectedArray, setFilesSelectedArray] = useState([])

  const onDragOver = (event) => {
    event.preventDefault()
  }

  const onDragLeave = () => {}

  const onDrop = (event) => {
    event.preventDefault()
    event.stopPropagation()
    Array.from(event.dataTransfer.files).forEach((file) => {
      const reader = new FileReader()
      reader.onload = function () {
        let fileDataBase64 = reader.result
        let fileDataReturn = {
          fileDataBase64,
          name: file.name,
          size: file.size,
          type: file.type,
          origin: 'gallery',
        }
        setFilesSelectedArray((current) => [...current, fileDataReturn])
      }
      reader.readAsDataURL(file)
    })
  }
  function formatBytes(bytes, decimals = 0) {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }

  function onFileChange(e) {
    Array.from(e.target.files).forEach((file) => {
      const reader = new FileReader()
      reader.onload = function () {
        let fileDataBase64 = reader.result
        let fileDataReturn = {
          fileDataBase64,
          name: file.name,
          size: file.size,
          type: file.type,
        }
        setFilesSelectedArray((current) => [...current, fileDataReturn])
      }
      reader.readAsDataURL(file)
    })
  }

  const handleRemoveFile = (index) => {
    setFilesSelectedArray((current) => current.filter((_, i) => i !== index))
  }

  const addImages = async () => {
    if (onSave) {
      onSave(filesSelectedArray)
    }
    if (onClose) {
      onClose()
    }
  }

  return (
    <div className={styles.modal}>
      <div className={styles.header_close}>
        <div className={styles.close_modal} onClick={onClose}>
          <Cross width={'20px'} height={'20px'} />
        </div>
      </div>
      <div className={styles.modal_title}>
        <h2 className={styles.modal_title_text}>
          Realize upload dos elementos <Interrogation color={'#FF8B00'} />
        </h2>
      </div>
      <div className={styles.modal_sub_title}>
        <p className={styles.modal_sub_title_text}>
          Realize uploads arrastando os elementos para área demarcada ou
          selecione do explorador de arquivos
        </p>
      </div>
      <div className={styles.container_modal}>
        <div className={styles.content_up_image}>
          <div className={styles.modal_container_drag}>
            <div className={styles.modal_drag}>
              <div
                className={styles.modal_drag_drop}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
              >
                <label htmlFor="arquivo">
                  <CloundArrowUp color={'#B900FE'} />
                  <h2
                    className={
                      filesSelectedArray.length !== 0
                        ? styles.modal_drag_drop_title_short
                        : styles.modal_drag_drop_title
                    }
                  >
                    Arraste & Solte o arquivo
                  </h2>
                  <p
                    className={
                      filesSelectedArray.length !== 0
                        ? styles.modal_drag_drop_sub_title_short
                        : styles.modal_drag_drop_sub_title
                    }
                  >
                    Ou selecione o arquivo no explorador
                  </p>
                </label>
                <input
                  type="file"
                  name="arquivo"
                  id="arquivo"
                  onChange={(e) => onFileChange(e)}
                ></input>
              </div>
            </div>
          </div>
          <div className={styles.modal_button_save}>
            <button className={styles.button_add}>
              <label className={styles.button_add_label} htmlFor="arquivo">
                Adicionar Imagem
              </label>
            </button>
          </div>
        </div>
        {filesSelectedArray.length !== 0 && (
          <div className={styles.content_list_image}>
            <div className={styles.container_box_list_image}>
              {filesSelectedArray.map((image, index) => (
                <div
                  key={index}
                  className={styles.container_list_image}
                >
                  <div className={styles.item_list_image}>
                    <img
                      src={image.fileDataBase64}
                      alt="file-preview"
                    />
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.8 }}
                      className={styles.box_data_info}
                    >
                      <p className={styles.box_data_info_title}>
                        {image.name}
                      </p>
                      <p className={styles.box_data_info_size}>
                          Tamanho &nbsp;<b> {formatBytes(image.size)} </b>
                      </p>
                    </motion.div>
                  </div>
                  <div className={styles.item_list_image_buttons}>
                    <button
                      className={styles.button_cancel}
                      onClick={() => handleRemoveFile(index)}
                    >
                      <p className={styles.button_cancel_title}>Excluir</p>
                      <Trash />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {filesSelectedArray.length !== 0 && (
        <button className={styles.button_save} onClick={() => addImages()}>
          Adicionar Imagens
        </button>
      )}
    </div>
  )
}

export default ModalGallery
